import { Component, Input } from '@angular/core';
import { ThemeService } from '../../service/theme.service';

@Component({
  selector: 'app-login-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['../login.component.css', './new-password.component.css'],
  standalone: false,
})
export class NewPasswordComponent {
  // Context bridge to parent login component
  @Input() ctx: any;
  @Input() loading = false;

  constructor(public theme: ThemeService) {}
}
